<ng-container *ngIf="data$ | async as data; else loading">
  <div class="pdf-viewer-container" [class.single-page]="!!page">
    <app-pdf-page
      *ngFor="let item of data; trackBy: trackByPageNumber"
      [page]="item.page"
      [viewport]="item.viewport"
      [scaleFactor]="scaleFactor"
      [height]="item.height"
      [width]="item.width"
    ></app-pdf-page>
  </div>
</ng-container>
<ng-template #loading>
  <div class="pdf-viewer-placeholder">
    <app-loading-v2 [showMessage]="false"></app-loading-v2>
  </div>
</ng-template>
